// app/features/activation/hooks/activationNewsletterCommand.ts

export interface ActivationNewsletterEligibility {
  hasUser: boolean;
  hasCompletedOnboarding: boolean;
}

let claimedThisSession = false;

export function shouldClaimActivationNewsletter(input: {
  hasUser: boolean;
  hasCompletedOnboarding: boolean;
  alreadyClaimed: boolean;
}): boolean {
  return input.hasUser && input.hasCompletedOnboarding && !input.alreadyClaimed;
}

/**
 * Session-level claim so org/workflow/newsletter success paths can share
 * one frontend attempt. The backend endpoint remains independently idempotent.
 */
export function claimActivationNewsletterOnce(
  eligibility: ActivationNewsletterEligibility,
): boolean {
  if (
    !shouldClaimActivationNewsletter({
      ...eligibility,
      alreadyClaimed: claimedThisSession,
    })
  ) {
    return false;
  }
  claimedThisSession = true;
  return true;
}

export function resetActivationNewsletterClaimForTests(): void {
  claimedThisSession = false;
}

export async function runActivationNewsletterCommand(
  trigger: () => Promise<unknown>,
): Promise<void> {
  try {
    await trigger();
  } catch {
    // The next successful activation command may retry.
  }
}
